export default {
  data(){
    return {
      headerHeight  : null,
      footerHeight  : null,
      boxHeight     : null,
      iconHeight    : null,

      boxHeightOffset : 10
    };
  },
  
  methods : {
    getHeaderHeight(){
      if(typeof this.$refs.headerField === 'undefined') return null;

      const rectSet = this.$refs.headerField.getBoundingClientRect();

      const styleSet = window.getComputedStyle(this.$refs.headerField);

      return Math.ceil(rectSet.height + parseInt(styleSet.marginTop));
    },

    getFooterHeight(){
      if(typeof this.$refs.footerField === 'undefined') return null;

      const rectSet = this.$refs.footerField.getBoundingClientRect();

      return Math.ceil(rectSet.height);
    },

    getDetailBoxHeight(){
      if(typeof this.$refs.detailBox === 'undefined') return null;

      const rectSet = this.$refs.detailBox.getBoundingClientRect();
      
      return Math.ceil(rectSet.height);
    },

    getIconFieldHeight(){
      if(typeof this.$refs.iconField === 'undefined') return null;

      const rectSet = this.$refs.iconField.getBoundingClientRect();
      
      return Math.ceil(rectSet.height);
    },

    setModalContentHeight(){
      const maxTime   = 50;
      let timeCounter = 0;
      
      const intervalTimer = setInterval(() => {
        timeCounter++;

        if(timeCounter > maxTime){
          clearInterval(intervalTimer);
        }
        if(window.innerHeight === 0) return;

        this.headerHeight = this.getHeaderHeight();
        this.footerHeight = this.getFooterHeight();
        this.iconHeight   = this.getIconFieldHeight();
        this.boxHeight    = this.getDetailBoxHeight();

        this.iconHeightHalf = (this.iconHeight / 2);

        const fullDetailBoxHeight = this.boxHeight + this.iconHeightHalf;

        if(window.innerHeight < fullDetailBoxHeight){
          const headerAndFooterHeight = this.headerHeight + this.footerHeight + this.iconHeightHalf + this.boxHeightOffset;

          this.$refs.contentField.style.height = (window.innerHeight - headerAndFooterHeight) + 'px';
        }
        
        clearInterval(intervalTimer);
      }, 100);
    }
  }
}